import './index.scss';

const Footer = () => {
  const handleGoTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <div className="footer-wrap">
      <div className="footer_go-top" onClick={handleGoTop}>
        <div className="go-top-bg"></div>
        <div className="go-top-border"></div>
        <div className="go-top-content">
          <span className="go-top-arrow">↑</span>
          <span className="go-top-text">TOP</span>
        </div>
        <div className="go-top-pulse"></div>
      </div>
      <footer className="footer">
        <div className="main-content">
          <div className="footer_copy">版权所有：上海迷果科技有限公司</div>
          <i className='footer_line'>|</i>
          <div className="footer_address">公司地址：上海市宝山区淞南路479号2层  </div>
        </div>
      </footer>
      <div className="footer-bottom">
        <div className="main-content">
          <span className="footer-left_copy">Copyright © 2025-2026</span>
          <i className='footer_line'>|</i>
          <a className="footer-left_mail" href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
            ICP备案号：沪ICP备2026001252号-1
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
